import { SanctionType, SanctionTypeLabel } from '../../../../../../views/democracy/constants';

export function resolveSanctionTypeLabel(sanctionType) {
    if (!sanctionType) return 'Без типа';
    return sanctionType.displayName || SanctionTypeLabel[sanctionType.name] || sanctionType.name || 'Без типа';
}

// Нормализует список типов санкций с бэкенда к полному набору SanctionType.
export function normalizeSanctionTypes(raw) {
    const remote = Array.isArray(raw) ? raw : [];
    const byName = new Map();
    remote.forEach((entry) => {
        const name = entry && (entry.name || entry.value || entry.code);
        if (name && SanctionType[name]) {
            byName.set(name, {
                name,
                orderId: entry.orderId ?? null,
                displayName: entry.displayName || SanctionTypeLabel[name] || name
            });
        }
    });
    return Object.values(SanctionType).map((name, idx) => byName.get(name) || {
        name,
        orderId: idx + 1,
        displayName: SanctionTypeLabel[name] || name
    });
}
